<script>

import UserList from '@/views/AadenPages/VipPage/UserCenter/UserList.vue'
import BlInfo from '@/views/AadenPages/VipPage/UserCenter/BlInfo.vue'

export default {
  name: 'UserIndex',
  components: {
    BlInfo,
    UserList
  },
  data () {
    return {
      tab: null
    }
  }
}
</script>

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>用户列表</v-tab>
      <v-tab>BL信息</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <user-list />
      </v-tab-item>
      <v-tab-item>
        <bl-info />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style scoped>

</style>
